<div class="centered">
<mat-card class="speech-bubble">
  <table style="width: 100%; padding: 0px; margin: 0px; text-align: center">
    <tr>
      <td class="upperTd">
        <div class="maherlogo"></div>
        <div class="lock"></div>
        <div class="titleFont" style="padding-bottom: 10px;  text-align: center">Enter Security Code </div>
        <form  [formGroup]="myForm" autocomplete="off"   novalidate>
          <table  class="table-fill">
            <td style="width: 90%">
              <mat-form-field appearance="outline" style="min-width: 100%" >
                <mat-label>Code</mat-label>
                <input maxlength="6" #confirmCode [(ngModel)]="myUser.passwordResetCode" oninput="this.value = this.value.toUpperCase()" matInput formControlName="code"   />
              </mat-form-field>
            </td>
            <td style="vertical-align: middle;">
              <button mat-raised-button class="blueButton"  (click)="validateResetPassword()" color="primary" [disabled]="goodCode"><img style="height: 25px; width: 25px;  padding-top: 13px; padding-bottom: 13px"  src="assets/check_circle_white.png" ></button>
            </td>

            <tr>
              <td colspan="2">
                <span *ngIf="f.code.errors" class="invalid-feedback">
                 <div class="errorDiv2"  *ngIf="f.code.errors.required && submitted">Code Required</div>
              </span>
                <div class="errorDiv2"  *ngIf="maherError!=null && submitted">{{maherError}}</div>
                <div *ngIf="!goodCode" class="errorDiv2" style="font-size: 17px;  text-align: center">Code Expires In:
                <countdown class="errorDiv2" style="font-size: 20px" #myTimer  [config]="{leftTime: 600, format: 'mm:ss'}" (event)="bustOut($event)" ></countdown>
                </div>

              </td>
            </tr>
          </table>
        </form>


              <form  [formGroup]="myForm2" autocomplete="off"   novalidate>
                <table style="width: 100%; padding: 0px; margin: 0px; padding-left: 19px ">
                  <tr >
                    <td style="text-align: left; width: 46%; " >
                      <mat-form-field appearance="outline" style="width: 100%" >
                        <mat-label >Password</mat-label>
                        <input maxlength="20"   (keyup)="checkRules()"  [type]="activePass ? 'password' : 'text'" matInput formControlName="password" />
                        <div matSuffix matTooltip="show/hide password" (click)="showPassword()"  style="font-size: 13px;cursor: pointer; " >
                          <a *ngIf="activePass" >SHOW </a>
                          <a *ngIf="!activePass">HIDE </a>
                        </div>
                      </mat-form-field>
                      <span *ngIf="g.password.errors" class="invalid-feedback" style="text-align: center">
                  <div class="errorDiv2"  *ngIf="g.password.errors.required && submitted2">Both Password/Confirm Password Are Required</div>
                </span>
                      <mat-form-field appearance="outline" style="width: 100%" >
                        <mat-label  >Confirm Password</mat-label>
                        <input maxlength="20" [type]="activeConfirm ? 'password' : 'text'" matInput formControlName="confirm" />
                        <div matSuffix matTooltip="show/hide password" (click)="showConfirmPassword()"  style="font-size: 13px;cursor: pointer">
                          <a *ngIf="activeConfirm ">SHOW </a>
                          <a *ngIf="!activeConfirm ">HIDE </a>
                        </div>
                      </mat-form-field>
                    </td>
                    <td style="text-align: -webkit-center; text-align: -moz-center;vertical-align: bottom; padding-left: 29px">
                      <div style="background-color:#efefef;text-align: left; padding-top: 15px; width: 100%">
                        <div style="font-weight: bolder; font-size: 16px; text-align: center">Your password must contain at least:</div>
                        <div style="font-weight: lighter; font-size: 14px; padding-left: 80px"><mat-icon matPrefix ><img style="vertical-align: center; height: 17px" [src]="totalFound>5 ? 'assets/greenCheck.png': 'assets/troubleRed.png'"  ></mat-icon>5 or more Characters</div>
                        <div style="font-weight: lighter; font-size: 14px; padding-left: 80px"><mat-icon matPrefix ><img style="vertical-align: center; height: 17px" [src]="lowerFound>2 ? 'assets/greenCheck.png': 'assets/troubleRed.png'" ></mat-icon>3 Lowercase letters</div>
                        <div style="font-weight: lighter; font-size: 14px; padding-left: 80px"><mat-icon matPrefix ><img style="vertical-align: center; height: 17px" [src]="numberFound>0 ? 'assets/greenCheck.png': 'assets/troubleRed.png'" ></mat-icon>1 Number</div>
                        <div style="font-weight: lighter; font-size: 14px; padding-left: 80px; padding-bottom: 11px"><mat-icon matPrefix ><img style="vertical-align: center;height: 17px" [src]="strangeFound>0 ? 'assets/greenCheck.png': 'assets/troubleRed.png'" ></mat-icon>1 Special Character</div>
                      </div>

                    </td>

                  </tr>
                </table>

              </form>



        <div *ngIf="goodCode" class="errorDiv2" style="font-size: 17px;  text-align: center">Code Expires In:
          <countdown class="errorDiv2" style="font-size: 20px" #myTimer2 [config]="{leftTime: 300, format: 'mm:ss'}" (event)="bustOut($event)" ></countdown>
        </div>
        <div style="padding-top: 5%">
          <button mat-raised-button class="redButton"  (click)="returnBack()" style="min-width: 27%" >Cancel</button>
          <span style="padding-right: 1%"></span>
          <button mat-raised-button class="blueButton" [disabled]="disableFields"  (click)="resetPassword()" color="primary" style="min-width: 27%">Submit New Password</button>
        </div>
        <div style="padding-top: 10px">
          <div class="errorDiv2"  *ngIf="formatError && submitted2">Password Did Not Meet Formatting Instructions</div>
          <div class="errorDiv2"  *ngIf="maherError!=null && submitted2">{{maherError}}</div>
          <div class="errorDiv2" style="font-size: 20px" *ngIf="navisErrors!='' && submitted2">{{navisErrors}}</div>
        </div>

      </td>
      <td class="lowerTd daPic">
      </td>
    </tr>
  </table>
</mat-card>
</div>
